import GetLatestRecord from './GetLatestRecord';

export default GetLatestRecord;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/GetLatestRecord/index.js